var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wam-content onboarding-georadar"},[_c('GeoradarPanel'),_c('GeoradarMap')],1)}
var staticRenderFns = []

export { render, staticRenderFns }